import * as Mutations from '../modules/registration/mutations';

export const UsernameSessionStoragePlugin = store => {
    const username = sessionStorage.getItem('email');
    username && store.commit(Mutations.SAVE_USERNAME, username);
};


// WEBPACK FOOTER //
// ./src/store/plugins/username-session-storage.plugin.js